<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="名称/联系电话/联系地址" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" @click="addVehicleDriverInfoModal=true">添加驾驶员信息</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-vehicle-driver-info-modal v-model="addVehicleDriverInfoModal" @on-success="onSuccess"></add-vehicle-driver-info-modal>
    <vehicle-driver-info-detail-modal v-model="vehicleDriverInfoDetailModal" :initValue="vehicleDriverInfoDetailId"
                                @on-success="onModifySuccess"></vehicle-driver-info-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
    <!--<business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo" :showBusinessState="false"-->
                                <!--@on-success="onSuccess"></business-note-detail-modal>-->
  </div>
</template>

<script>
import AddVehicleDriverInfoModal from '@/view/crm/components/add-vehicle-driver-info-modal'
import VehicleDriverInfoDetailModal from '@/view/crm/components/vehicle-driver-info-detail-modal'
// import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'vehicledriverinfos',
  components: {
    AddVehicleDriverInfoModal,
    VehicleDriverInfoDetailModal
    // BusinessNoteDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 添加收入项
      addVehicleDriverInfoModal: false,

      // 驾驶员信息详细信息
      vehicleDriverInfoDetailModal: false,
      vehicleDriverInfoDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        vehicleDriverInfoId: null
      },

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 100
        },
        {
          title: '驾驶员名称',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          width: 120
        },
        {
          title: '联系电话',
          resizable: true,
          key: 'phoneNum',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '司机卡号',
          resizable: true,
          key: 'driverCardNum',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '身份证号码',
          resizable: true,
          key: 'idCardNum',
          ellipsis: 'true',
          width: 220
        },
        {
          title: '联系地址',
          resizable: true,
          key: 'address',
          ellipsis: 'true',
          width: 200
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 180,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleDriverInfoDetailId = params.row.id
                    this.vehicleDriverInfoDetailModal = true
                  }
                }
              }, '详细信息')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'VehicleDriverInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      store.dispatch('VehicleDriverInfoServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_VehicleDriverInfo_GetPageResult) {
        return store.getters.get_VehicleDriverInfo_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_VehicleDriverInfo_GetPageResult) {
        return store.getters.get_VehicleDriverInfo_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_VehicleDriverInfo_GetPageResult) {
        return store.getters.get_VehicleDriverInfo_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
